import React, { useEffect, useContext, useState } from 'react';
import { Form } from 'react-bootstrap';
import { ProductContext } from '../../ProductProvider';

export default function BookReport(props) {
  // Modern styles for BookReport
  const bookReportModernStyles = `
    .book-report-bg {
      background: linear-gradient(135deg, #f8fafc 0%, #e0e7ef 100%);
      min-height: 100vh;
      padding: 0;
      font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
    }
    .book-report-title {
      font-size: 2rem;
      font-weight: 800;
      color: #1a2a4f;
      margin-bottom: 1.2rem;
      letter-spacing: 0.5px;
      text-align: center;
      text-shadow: 0 2px 8px rgba(44,62,80,0.07);
    }
    .book-report-stats-row {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 1.5rem;
      margin-bottom: 2rem;
    }
    .book-report-stat-card {
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 4px 16px 0 rgba(44, 62, 80, 0.10);
      padding: 1.2rem 1.5rem;
      min-width: 180px;
      max-width: 260px;
      flex: 1 1 180px;
      display: flex;
      flex-direction: column;
      align-items: center;
      transition: box-shadow 0.2s, transform 0.2s;
      border: 1.5px solid #e3eafc;
    }
    .book-report-stat-card:hover {
      box-shadow: 0 8px 32px 0 rgba(44, 62, 80, 0.16);
      transform: translateY(-4px) scale(1.03);
      border: 1.5px solid #4f8cff;
    }
    .book-report-stat-img {
      width: 48px;
      height: 48px;
      margin-bottom: 0.7rem;
      object-fit: contain;
      filter: drop-shadow(0 2px 8px rgba(44,62,80,0.07));
    }
    .book-report-stat-value {
      font-size: 2.1rem;
      font-weight: 700;
      color: #4f8cff;
      margin-bottom: 0.2rem;
      text-align: center;
    }
    .book-report-stat-label {
      font-size: 1.08rem;
      color: #2a3659;
      font-weight: 500;
      text-align: center;
      letter-spacing: 0.2px;
    }
    @media (max-width: 900px) {
      .book-report-title {
        font-size: 1.3rem;
      }
      .book-report-stat-card {
        min-width: 120px;
        padding: 0.8rem 0.7rem;
      }
      .book-report-stat-value {
        font-size: 1.3rem;
      }
    }
    @media (max-width: 700px) {
      .book-report-stats-row {
        flex-direction: column;
        align-items: stretch;
        gap: 1rem;
      }
      .book-report-stat-card {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: 0 auto;
      }
    }
    @media (max-width: 600px) {
      .book-report-title {
        font-size: 1.08rem;
        margin-bottom: 0.7rem;
      }
      .book-report-stats-row {
        gap: 0.7rem;
      }
      .book-report-stat-card {
        min-width: 90px;
        padding: 0.5rem 0.3rem;
      }
      .book-report-stat-value {
        font-size: 1.1rem;
      }
      .book-report-stat-label {
        font-size: 0.95rem;
      }
    }
    @media (max-width: 400px) {
      .book-report-title {
        font-size: 0.95rem;
      }
      .book-report-stat-card {
        padding: 0.3rem 0.1rem;
      }
    }
  `;
  const {searchResult, setSearchTopic, setSearchValue, searchTopic, searchValue } = props;
  const { generateDate, generateReturnDate } = useContext(ProductContext);
  const [issueDetails, setIssueDetails] =useState({dueBooks : [], nextDueBooks:[]})

  return (
    <div className="book-report-bg">
      <style>{bookReportModernStyles}</style>
      <section style={{paddingTop: '24px', paddingBottom: '24px'}}>
        <div className="book-report-title">Book's Report</div>
        {searchResult.length>0 && (
          <div className="book-report-stats-row">
            <div className="book-report-stat-card">
              <img className="book-report-stat-img" src="images/cat1.png" alt="Total Books" />
              <div className="book-report-stat-value">{searchResult[0]["Available"]+searchResult[0]["Issued"]+searchResult[0]["In-Active"]}</div>
              <div className="book-report-stat-label">Total Books</div>
            </div>
            <div className="book-report-stat-card">
              <img className="book-report-stat-img" src="images/cat1.png" alt="Available Books" />
              <div className="book-report-stat-value">{searchResult[0]["Available"]}</div>
              <div className="book-report-stat-label">Available Books</div>
            </div>
            <div className="book-report-stat-card">
              <img className="book-report-stat-img" src="images/cat1.png" alt="Issued Books" />
              <div className="book-report-stat-value">{searchResult[0]["Issued"]}</div>
              <div className="book-report-stat-label">Issued Books</div>
            </div>
            <div className="book-report-stat-card">
              <img className="book-report-stat-img" src="images/cat1.png" alt="In Active Books" />
              <div className="book-report-stat-value">{searchResult[0]["In-Active"]}</div>
              <div className="book-report-stat-label">In Active Books</div>
            </div>
          </div>
        )}
      </section>
    </div>
  )
}
